import React from 'react'
import NavPatient from '../../patients/navPatien/NavPatient'
import { useNavigate } from 'react-router-dom';
import Information from '../Information/Information';

function Relatedinfo() {
    return (
        <div className=''>
            <NavPatient menu={'relatedinfo'} />
            <Information type='patient' />
        </div>
    );
};

export default Relatedinfo